function Vision() {
  return (
    <section className="py-20 px-6 bg-bg-primary">
      <div className="max-w-5xl mx-auto">
        {/* The Problem */}
        <div className="text-center mb-20">
          <h2
            className="font-space text-[clamp(14px,2vw,18px)] tracking-[6px] uppercase mb-8"
            style={{
              color: "#FF6B00",
              fontWeight: "700",
            }}
          >
            The Problem
          </h2>

          <p
            className="font-space text-[clamp(28px,4vw,48px)] leading-tight mb-8"
            style={{
              color: "#b0b0b0",
              fontWeight: "600",
            }}
          >
            Editing clips from long videos takes hours.
          </p>

          <div className="max-w-3xl mx-auto">
            <p
              className="font-space text-[clamp(16px,2.2vw,20px)] leading-relaxed"
              style={{
                color: "#777777",
                fontWeight: "500",
              }}
            >
              Finding the best moments from a 2-hour stream. Cutting clips for
              TikTok, YouTube, Instagram, LinkedIn, and X. Posting everywhere.
              Tracking what works. Most creators spend more time on distribution
              than creation.
            </p>
          </div>
        </div>

        {/* The Solution */}
        <div className="text-center mb-20">
          <h2
            className="font-space text-[clamp(14px,2vw,18px)] tracking-[6px] uppercase mb-8"
            style={{
              color: "#FF6B00",
              fontWeight: "700",
            }}
          >
            The Solution
          </h2>

          <p
            className="font-space text-[clamp(28px,4vw,48px)] leading-tight mb-8"
            style={{
              color: "#b0b0b0",
              fontWeight: "600",
            }}
          >
            CreatorOS finds and cuts your viral moments automatically—in under
            60 seconds.
          </p>

          <div className="max-w-3xl mx-auto">
            <p
              className="font-space text-[clamp(16px,2.2vw,20px)] leading-relaxed"
              style={{
                color: "#777777",
                fontWeight: "500",
              }}
            >
              Upload any video. AI identifies highlights and exports clips
              instantly. Soon: auto-publish, track performance, optimize
              strategy.
            </p>
          </div>
        </div>

        {/* Platform Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {[
            { label: "Video Editing & Clipping", status: "Live" },
            { label: "Content Posting & Scheduling", status: "Soon" },
            { label: "Performance Tracking", status: "Soon" },
            { label: "Growth Strategy & Optimization", status: "Soon" },
          ].map((item, index) => (
            <div
              key={index}
              className="text-center py-8 px-4 border bg-bg-secondary"
              style={{
                borderColor: "#1c1c1c",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#FF6B00";
                e.currentTarget.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#1c1c1c";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <div
                className="font-space text-[11px] tracking-[1px] mb-3 leading-snug"
                style={{
                  color: "#b0b0b0",
                  fontWeight: "600",
                  minHeight: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {item.label}
              </div>
              <div
                className="font-space text-[9px] tracking-[3px] uppercase"
                style={{
                  color: item.status === "Live" ? "#FF6B00" : "#444444",
                  fontWeight: "700",
                }}
              >
                {item.status}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Vision;
